export default function PreviousLink({prevPage, ...props}) {
  return (
    <>
      {prevPage && (
        <li>
          <p onClick={() => props.onPaginationClick(prevPage)} className="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-green-600 hover:underline bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 cursor-pointer rounded-s-lg">
            <span className="sr-only">Previous</span>
            <svg className="w-2.5 h-2.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"/>
            </svg>
          </p>
        </li>
      )}
    </>
  )
}
